import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Addvance({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="Addvance Solutions" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="addvancePanel">
            <Trans i18nKey="addvanceDetails" />

            <h2 className="text-center titles text-green-700">{t("technologies")}</h2>

            <p className="text-center">InnoSetup, php, PrestaShop, Javascript, Python, REST Api</p>
        </Dialog>
    )
}